<template>
  <div class="card modal-card-border">
    <div class="card-content">
      <div class="columns">
        <div class="column is-8">
          <section>
            <div class="field has-addons">
              <p class="control">
                <a class="button is-primary">
                  À
                </a>
              </p>
              <p class="control">
                <b-taginput
                  class="input-contact"
                  type="is-primary"
                  v-model="mail.To">
                </b-taginput>
              </p>
            </div>
            <div class="field has-addons">
              <p class="control">
                <a class="button is-gris">
                  Cc
                </a>
              </p>
              <p class="control">
                <b-taginput
                  class="input-contact"
                  type="is-gris"
                  v-model="mail.Cc">
                </b-taginput>
              </p>
            </div>
            <div class="field has-addons">
              <p class="control">
                <a class="button is-gris">
                  Cci
                </a>
              </p>
              <p class="control">
                <b-taginput
                  class="input-contact"
                  type="is-gris"
                  v-model="mail.Cci">
                </b-taginput>
              </p>
            </div>
            <div class="field">
              <p class="control">
                <input class="input objet" type="search" placeholder="Objet" v-model="mail.Objet">
              </p>
            </div>
            <div class="field">
              <p class="control">
                <input class="input objet" type="email" placeholder="De" v-model="mail.replyTo">
              </p>
            </div>
            <div class="field">
              <p class="control">
                <textarea class="textarea" type="search" id="mailCorps"
                          placeholder="Ajoutez un message" v-model="mail.Corps">
                </textarea>
              </p>
            </div>
          </section>
        </div>
        <div class="column">
          <div class="field">
            Insérer l'opportunité en pièce jointe :
            <b-switch v-model="insererPdf"
                      type="is-primary">
            </b-switch>
          </div>
          <div class="field" v-if="this.afficherRecap">
            Insérer le récapitulatif réseau en pièce jointe :
            <b-switch v-model="insererRecap"
                      type="is-primary">
            </b-switch>
          </div>
          <b-field>
            <b-upload v-model="dropFiles"
                      multiple
                      drag-drop>
              <section class="section">
                <div class="content has-text-centered columns">
                  <span class="column is-2">
                    <b-icon
                      icon="upload"
                      size=""
                      type="is-primary">
                    </b-icon>
                  </span>
                  <span class="column">Ajouter une pièce jointe</span>
                </div>
              </section>
            </b-upload>
          </b-field>
          <div class="box"
               :key="index"
               v-for="(file, index) in dropFiles">
            <div class="columns">
              <div class="column is-2">
                <b-icon
                  icon="file-document"
                  size=""
                  type="is-default">
                </b-icon>
              </div>
              <div class="column">
                <span class=" ellipsis file_upload is-default">
                  {{file.name}}
                </span>
              </div>
              <div class="column is-2 delete_upload">
                <a class="is-small"
                   @click="deleteDropFile(index)">
                  <b-icon
                    icon="delete"
                    size="is-small"
                    type="is-gris">
                  </b-icon>
                </a>
              </div>
            </div>
          </div>
          <div class="tags">
          </div>
        </div>
      </div>
      <b-field>
      <button class="button is-primary margin-right-10"
              @click="envoyerMail">
        Envoyer
      </button>
      <button class="button is-primary margin-right-10" @click="insertionLien()"
              v-if="hasPortailAnnonceur === true">
        <b-icon
          icon="link-variant" class="margin-right-10">
        </b-icon>
        Ajouter le lien
      </button>
      <span class="is-size-7 couleurFontDefault margin-right-10"
            v-if="hasPortailAnnonceur === true">
        Ce bouton vous permet d'ajouter le lien  de <br> l'opportunité
        dématérialisée dans le corps <br>du mail.
      </span>
      <button class="button is-gris"
              @click="annuler()"
              v-if="disabled">
        Annuler
      </button>
      </b-field>
    </div>
  </div>
</template>

<script>
import envoiMail from '@/services/general/envoiMail';
import { createNamespacedHelpers } from 'vuex';
import gestionErreur from '@/services/general/gestionErreur';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import * as typesPanier from '@/store/creationOpportunite/panier-mutation-type';
import { browseDetailClient } from '@/api/clients/index';

const Panier = createNamespacedHelpers('panier');
const User = createNamespacedHelpers('user');
const Modal = createNamespacedHelpers('modal');

export default {
  name: 'envoi-mail',
  props: ['disabled', 'opportuniteId', 'opportuniteContact', 'afficherRecap', 'permalink', 'opportuniteClientId'],
  data() {
    return {
      dropFiles: [],
      mail: {
        To: [],
        Cc: [],
        Cci: [],
        Objet: null,
        replyTo: null,
        Corps: '',
      },
      insererPdf: true,
      insererRecap: this.afficherRecap,
    };
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open({ container: null });
    try {
      if (this.userEmail) {
        this.mail.Cci.push(this.userEmail);
        this.mail.replyTo = this.userEmail;
      }
      if (this.opportuniteContact && this.opportuniteContact.email) {
        this.mail.To.push(this.opportuniteContact.email);
      }
      if (this.opportuniteClientId) {
        const client = (await browseDetailClient(this.opportuniteClientId)).data;
        if (client.email) this.mail.To.push(client.email);
      }
      loadingComponent.close();
    } catch (error) {
      loadingComponent.close();
    }
  },
  computed: {
    ...Modal.mapGetters({
      getIsComponentEnregistrerOpportuniteActive: 'isComponentEnregistrerOpportuniteActive',
      getIsComponentConfirmationMail: 'isComponentConfirmationMail',
      getIsComponentOuvrirEnvoiMail: 'isComponentOuvrirEnvoiMail',
    }),
    ...User.mapGetters({
      userEmail: 'userEmail',
      hasPortailAnnonceur: 'hasPortailAnnonceur',
    }),
    isComponentEnregistrerOpportuniteActive: {
      get() {
        return this.getIsComponentEnregistrerOpportuniteActive;
      },
      set(value) {
        this.setIsComponentEnregistrerOpportuniteActive(value);
      },
    },
    isComponentConfirmationMail: {
      get() {
        return this.getIsComponentConfirmationMail;
      },
      set(value) {
        this.setIsComponentConfirmationMail(value);
      },
    },
    isComponentOuvrirEnvoiMail: {
      get() {
        return this.getIsComponentOuvrirEnvoiMail;
      },
      set(value) {
        this.setIsComponentOuvrirMail(value);
      },
    },
  },
  methods: {
    ...Modal.mapMutations({
      setIsComponentOuvrirMail: typesModal.SET_IS_COMPONENT_OUVRIR_MAIL,
      setIsComponentEnregistrerOpportuniteActive:
      typesModal.SET_IS_COMPONENT_ENREGISTRER_OPPORTUNITE_ACTIVE,
      setIsComponentConfirmationMail: typesModal.SET_IS_COMPONENT_CONFIRMATION_MAIL,
    }),
    ...Panier.mapMutations({
      setDestinataires: typesPanier.SET_DESTINATAIRES,
    }),
    insertionLien() {
      const mailCorps = document.getElementById('mailCorps');
      const positionCursor = mailCorps.selectionStart;
      this.mail.Corps = this.mail.Corps.substring(0, positionCursor) +
        this.permalink + this.mail.Corps.substring(positionCursor);
    },
    async envoyerMail() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      const payload = {
        mail: this.mail,
        dropFiles: this.dropFiles,
        insererPdf: this.insererPdf,
        insererRecap: this.insererRecap,
        url: 'opportunites/' + this.opportuniteId + '/action/mail/' + this.insererPdf + '/' + this.insererRecap,
      };
      try {
        if (await envoiMail(loadingComponent, payload)) {
          const destinataires = this.mail.To.map((el) => el).reduce((accumulator, currentValue) => accumulator + ', ' + currentValue);
          this.setDestinataires(destinataires);
          this.setIsComponentConfirmationMail(true);
          this.isComponentOuvrirEnvoiMail = false;
          this.$emit('close');
        }
        loadingComponent.close();
      } catch (e) {
        gestionErreur('Erreur lors de l\'envoi du mail', e);
        loadingComponent.close();
        throw e;
      }
    },
    deleteDropFile(index) {
      this.dropFiles.splice(index, 1);
    },
    annuler() {
      this.isComponentOuvrirEnvoiMail = false;
      this.isComponentEnregistrerOpportuniteActive = true;
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
  a {
    width: 50px;
  }

  .input, .input-contact {
    width: 550px;
  }

  .objet {
    width: 650px;
  }
  .textarea {
    height: 350px;
  }

  .box {
    background-color: #F2F7FC;
    width: 300px;
  }

  .file_upload {
    font-size: 14px;
    width:180px;
    display:inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/envoyerOpportunite/envoiMail.vue